import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faTiktok,
  faXTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import logo from "./assets/FullnuunLogoV2.png";
import { useAuth } from './AuthContext';
export default function Footer() {
  const { userLoggedIn } = useAuth();
  return (
    <footer className="nuun-footer">
      <div className="nuun-wrap">
        <div className="nuun-footer-top">
          <Link to="/" aria-label="NUUN home">
            <img className="nuun-brand" src={logo} alt="NUUN" />
          </Link>
          <div className="nuun-footer-right">
          <nav aria-label="Footer navigation">
            <Link to="/browse-events">Browse Events</Link>
            <a href="/#why-nuun">Why NUUN</a>
            <a href="/#cities">Cities</a>
            <a href="/#contact">Contact</a>
            {userLoggedIn ? <Link to="/events">Manage Events</Link> : <Link className="nuun-login-link" to="/login">Log in</Link>}
          </nav>
          <div className="nuun-socials">
            {[
              [faInstagram, "https://www.instagram.com/nuun_app/", "Instagram"],
              [faTiktok, "https://www.tiktok.com/@nuun_app", "TikTok"],
              [faXTwitter, "https://x.com/nuunevents", "X"],
              [
                faLinkedinIn,
                "https://www.linkedin.com/company/nuun-app",
                "LinkedIn",
              ],
            ].map(([icon, url, label]) => (
              <a
                key={label}
                href={url}
                aria-label={label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={icon} />
              </a>
            ))}
          </div>
          </div>
        </div>
        <p className="nuun-footer-fine">
          NUUN — Middle Eastern &amp; SWANA live events, in one app.<br />
          © {new Date().getFullYear()} NUUN All Rights Reserved
          {" · "}
            <Link to="/terms-of-use">Terms of Use</Link>
          {" · "}
            <Link to="/privacy-policy">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  );
}
